import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
import { Layout, Breadcrumb, Button, Card, Tabs, Spin, Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import { LayoutTopSide } from "components/NavBar/styles";
import { MyReports } from "./MyReports";
import { SharedReports } from "./SharedReports";
import { reportAPI } from "../../../services/actions/reports-v2";
import NewReport from "../../Reports/All/NewReport";
import _ from "lodash";
import moment from "moment";
import { useLocation } from "react-router-dom";

function Reports({ user, report }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Use URLSearchParams para ler a aba ativa e o filtro
  const urlParams = new URLSearchParams(location.search);

  // Inicializa a aba ativa (padrão é '0')
  const activeKey = urlParams.get("tab") || "0";

  // Função para mudar a aba e atualizar a URL
  const handleTabChange = (key) => {
    const newUrlParams = new URLSearchParams(location.search);
    newUrlParams.set("tab", key);

    navigate({
      pathname: location.pathname,
      search: newUrlParams.toString(),
    });
  };

  const routes = [
    {
      breadcrumbName: "Relatórios",
      href: "/relatorios",
    },
    {
      breadcrumbName: "todos",
    },
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [myReports, setMyReports] = useState([]);
  const [sharedReports, setSharedReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      search: false,
      sorter: true,
      title: "Nome",
      dataIndex: "name",
      key: "name",
      render: (dom, record, index, action, schema) => {
        const text = record[schema.dataIndex];
        if (text) {
          return (
            <Button
              type="link"
              style={{
                color: "#0e9c84",
              }}
              onClick={() => navigate(`/relatorios/editar/${record.id}`)}
            >
              {text}
            </Button>
          );
        }

      },
      width: "auto",
      ellipsis: true,
      valueType: "text",
      fieldProps: {
        placeholder: "",
      },
    },
    {
      sorter: true,
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      valueType: "text",
      responsive: ["md"],
      fieldProps: {
        placeholder: "",
      },
      render: (dom, record, index, action, schema) => {
        const text = record[schema.dataIndex];
        if (text) {
          return (<Tooltip placement="bottom" title={text}>
            <Button>{text.substring(0, 35) + "..."}</Button>
          </Tooltip>)
        }

      },
      width: "auto",
      ellipsis: true,
      search: false
    },
    {
      search: false,
      sorter: true,
      title: "Ações",
      dataIndex: "actions",
      key: "actions",
      render: (dom, record, index, action, schema) => {
        return (
          <Button
            type="primary"
            onClick={() => navigate(`/relatorios/visualizar/${record.id}`)}
          >
            Visualizar
          </Button>
        );

      },
      width: "auto",
      ellipsis: true,
    },
    {
      sorter: true,
      title: "Criado em",
      dataIndex: "created_at",
      key: "created_at",
      responsive: ["lg"],
      render: (dom, entity, index, action, schema) => {
        if (action) {
          return moment(entity[schema.dataIndex], "YYYY-MM-DDTHH:mm:ss[Z]").format("DD/MM/YYYY HH:mm");
        }
      },
      width: "auto",
      ellipsis: true,
      search: false
    },
    {
      sorter: true,
      title: "Atualizado em",
      dataIndex: "updated_at",
      key: "updated_at",
      responsive: ["lg"],
      render: (dom, entity, index, action, schema) => {
        if (action) {
          return moment(entity[schema.dataIndex], "YYYY-MM-DDTHH:mm:ss[Z]").format("DD/MM/YYYY HH:mm");
        }
      },
      width: "auto",
      ellipsis: true,
      search: false
    }

  ];

  const getReports = async () => {
    setLoading(true); // Inicia o loading
    const responses = await Promise.all([
      reportAPI.getSharedReports(),
      reportAPI.getMyReports(),
    ]);
    const existError = responses.filter(({ status }) => status !== 200);
    if (existError.length === 0 && report && report.user) {
      let [shared, mine] = responses.map(({ data }) => data);
      const all = _.uniqBy([...shared, ...mine], 'id');
      setMyReports(all.filter(({ collection_id }) => collection_id === report.user.personal_collection_id));
      setSharedReports(all.filter(({ collection_id }) => collection_id !== report.user.personal_collection_id));
    }
    setLoading(false); // Finaliza o loading
  };

  useEffect(() => {
    getReports();
  }, []);

  return (
    (<LayoutTopSide style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar />
      <Layout style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "row" }}>
        <DrawerSider />
        <Layout style={{ padding: "0 24px 24px", height: "100%", overflowY: "auto" }}>
          <PageHeader
            style={{ margin: "16px 0 5px 0" }}
            title="Lista de relatórios"
            subTitle="Visualize e acompanhe os relatórios disponíveis para análise dos seus dados."
            breadcrumb={
              <Breadcrumb>
                {routes.map((a) =>
                  a.hasOwnProperty("href") ? (
                    <Breadcrumb.Item key={Math.random()}>
                      <a href onClick={() => navigate(a.href)}>
                        {a.breadcrumbName}
                      </a>
                    </Breadcrumb.Item>
                  ) : (
                    <Breadcrumb.Item key={Math.random()}>{a.breadcrumbName}</Breadcrumb.Item>
                  )
                )}
              </Breadcrumb>
            }
          />
          <Card>
            {loading ? ( // Exibe o carregamento se true
              (<Spin size="large" />)
            ) : (
              <Tabs
                defaultActiveKey={"0"}
                activeKey={activeKey}
                onChange={handleTabChange}
                items={[
                  {
                    key: "0",
                    label: "Meus Relatórios",
                    children: <MyReports columns={columns} report={report} data={myReports} setIsModalVisible={setIsModalVisible} tabKey="0" navigate={navigate} location={location} getReports={getReports} />,
                  },
                  {
                    key: "1",
                    label: "Relatórios Compartilhados",
                    children: <SharedReports columns={columns} report={report} data={sharedReports} setIsModalVisible={setIsModalVisible} tabKey="1" navigate={navigate} location={location} getReports={getReports} />,
                  },
                ]}
              />
            )}
          </Card>
          <NewReport isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} getReports={getReports} />
        </Layout>
      </Layout>
    </LayoutTopSide>)
  );
}

const mapStateToProps = ({ session, report }) => ({
  user: session.user,
  report: report,
});

export default connect(mapStateToProps)(Reports);
